export default __webpack_public_path__ + "static/media/logo.bb54c8d4.svg";